import { ArrowDown, ArrowUpRight } from "lucide-react";

export const InvestorHero = () => {
  const goToForm = () => document.getElementById("investor-contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="relative min-h-[88svh] overflow-hidden bg-[#080909] text-[#faf9f5]" data-testid="invest-hero">
      <video
        autoPlay
        loop
        muted
        playsInline
        poster="/assets/video/hero-cucumber-melon-poster.jpg"
        className="absolute inset-0 h-full w-full object-cover object-[62%_center] opacity-65 md:object-center"
        data-testid="invest-hero-video"
      >
        <source src="/assets/video/hero-cucumber-melon.webm" type="video/webm" />
        <source src="/assets/video/hero-cucumber-melon.mp4" type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(8,9,9,0.96)_0%,rgba(8,9,9,0.82)_42%,rgba(8,9,9,0.14)_76%)]" />

      <div className="relative z-10 mx-auto flex min-h-[88svh] max-w-site flex-col px-6 md:px-10">
        <header className="flex h-20 items-center justify-between border-b border-white/15" data-testid="invest-header">
          <a href="/" className="block transition-opacity duration-200 hover:opacity-70" data-testid="invest-logo-link">
            <img src="/assets/brand/Vitura-White.png" alt="Vitura" className="h-auto w-32" />
          </a>
          <button
            type="button"
            onClick={goToForm}
            className="inline-flex items-center gap-2 border border-white/30 px-4 py-3 label !text-[9px] !text-white transition-colors duration-200 hover:bg-white hover:!text-black"
            data-testid="invest-header-cta"
          >
            Schedule a call <ArrowUpRight size={13} />
          </button>
        </header>

        <div className="flex flex-1 flex-col justify-end pb-10 pt-24 md:pb-14 lg:max-w-[760px]">
          <div className="label !text-[10px] !text-white/65" data-testid="invest-hero-eyebrow">Investor briefing · Vitura Labs™</div>
          <h1 className="mt-6 font-display text-5xl leading-[0.94] sm:text-6xl lg:text-7xl" data-testid="invest-hero-title">
            Five days.<br />Then let’s <span className="editorial font-normal">talk.</span>
          </h1>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-white/72" data-testid="invest-hero-copy">
            You received the sample because Vitura is best understood in motion. Run it five days straight. If it earns a place in your routine, we would like to show you the company being built around it.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-5">
            <button
              type="button"
              onClick={goToForm}
              className="inline-flex min-h-12 items-center gap-3 bg-[#faf9f5] px-6 py-3 label !text-[10px] !text-[#0f0f10] transition-colors duration-200 hover:bg-[#a8c69f]"
              data-testid="invest-hero-cta"
            >
              Schedule a founder call <ArrowUpRight size={14} />
            </button>
            <a href="#briefing" className="inline-flex min-h-12 items-center gap-2 label !text-[10px] !text-white/75 transition-opacity duration-200 hover:opacity-60" data-testid="invest-read-briefing-link">
              Read the briefing <ArrowDown size={14} />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-3 border-t border-white/15 py-5 text-white/75" data-testid="invest-hero-protocol">
          {[['5', 'Bottles'], ['5', 'Mornings'], ['1', 'Signal']].map(([value, label]) => (
            <div key={label} className="border-r border-white/15 px-4 first:pl-0 last:border-r-0">
              <span className="font-display text-2xl text-white">{value}</span>
              <span className="ml-2 label !text-[8px] !text-white/55">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};